import React from 'react';
const imgSize = {
  "minimumImageSize": (process.env.REACT_APP_MINIMUM_IMAGE_SIZE) ? process.env.REACT_APP_MINIMUM_IMAGE_SIZE : 100,
  "maximumImageSize": (process.env.REACT_APP_MAXIMUM_IMAGE_SIZE) ? process.env.REACT_APP_MAXIMUM_IMAGE_SIZE : 5
}
export const Constants = {
  "extractionKeys": ["Address", "Age", "Country", "Date of birth", "First name", "Height", "Id number", "Last name", "Nationality"],
  "staticKey": "Identifier",
  "headerInvalidIdException": "Template Name Validation Exception",
  "infoInvalidIdException": "Not a valid Template Name (must not include spaces or special characters)",
  "headerKeyExceptionBBX": "Bounding Box Validation Exception",
  "infoKeyMultipleBBX": "Same key is assigned to multiple bounding boxes.\n You need to assign a unique key for bounding boxes",
  "infoKeyUnassignedBBX": "Unassigned bounding box found.\nYou need to assign a key for each bounding box",
  "infoMinimumBBXValidation": "Please select at least four identifiers and one key",
  "headerKeyImgNotSelected": "Image Validation Exception",
  "infoKeyImgNotSelected": "No image selected.\nPlease select an image to be tagged",
  "headerDeleteTemplate": "Template Deleted",
  "infoDeleteTemplate": "Template deleted successfully",
  "infoImageSizeValidation": `Selected image file size must be in between ${imgSize.minimumImageSize} KB and ${imgSize.maximumImageSize} MB`,
  "headerKeyIdNa": "Template Name Validation Exception",
  "infoKeyIdNa": "Template Name can't be empty.\nPlease provide a valid Template Name ",
  "infoTemplateCreated": "Template submitted successfully",
  "headerTemplateCreatedStatus": "Template Create Status",
  "infoTemplateUpdated": "Template updated successfully",
  "headerTemplateUpdatedStatus": "Template Update Status",
  "templateUpdatingErrorMessage": "Exception occured while updating the template",
  "templateCreatedErrorMessage": "Exception occured while creating the template",
  "headerImageUploadError": "Upload Image Error",
  "headerDeletionError": "Error in deleting templates",
  "headerDownloadError": "Error in downloading templates",
  "headerUploadStatus": "Upload Status",
  "headerUploadFailed": "Upload Failed",
  "headerImageSizeValidation": "Image size validation",
  "thumbnail": "/1",
  "fullImage": "/0",
  "authenticateUser": "/innoveo/authenticate",
  "getTokenValidityStatus": "/innoveo/is-valid-token",
  "getOverallHealth": "/innoveo/health",
  "submitDataApi": "/innoveo/tagger/submit-data",
  "cropImageApi": "/innoveo/tagger/crop-image",
  "uploadImageApi": "/innoveo/tagger/upload-image",
  "getTemplates": "/innoveo/tagger/templates",
  "getTemplateImage": "/innoveo/tagger/fetch-template-image/",
  "getTaggingData": "/innoveo/tagger/fetch-tagging-data/",
  "downloadTaggingData": "/innoveo/tagger/download-template/",
  "uploadTemplate": "/innoveo/tagger/upload-all-template/",
  "deleteTemplate": "/innoveo/tagger/delete-template/",
  "validateTemplateIdUrl": "/innoveo/tagger/validate-template-id",
  "createTemplate": "create-template",
  "changeInZoom": 0.2,
  "minimumZoomThreshold": 0.0001,
  "Successful": "Successful",
  "All": "All",
  "Failed": "Failed",
  "Processing": "Processing",
  "pageSize": 8,
  "resendRequestTime": 5000,
  "ContentType": "application/json; charset=UTF-8",
  "AllTemplatesZipName": "AllTemplates.zip",
  "editMode": 'edit',
  "imgFileName": "image.jpg",
  "templateUnderProcessingHeadder": "This template is under processing please wait and try again later",
  "searchExistingTemplate": "Search template",
  "lastModified": "Last modified",
  "Alphabetical": "Alphabetical",
  "infoUploadFailed": "Please select a proper file format",
  "generalErrorMessage": "An error has occurred. Please contact your system administrator",
  "headerGetImageError": "Error in fetching Image",
  "headerGetAnnotationError": "Error in fetching tagged data",
  "headerCheckStatusError": "Error in checking status",
  "headerSendingTaggedData": "Error in sending the tagging data",
  "maxLengthTemplateId": 47,
  "deleteConfirmation": "Are you sure you want to delete the selected items?",
  "dragDropText": `Please upload an image between ${imgSize.minimumImageSize} KB and ${imgSize.maximumImageSize} MB`,
  "identifierRequired": 4,
  "templateIdExistMessage": "Template name must be unique",
  "emptyTemplateName": "Please enter a valid template name",
"assignBoundingAreaHelpText": `Position the boxes around the desired text or identification making on the upload image. At least four identifiers and a key must be defined for a valid template.`,
  "minimumImageSize": imgSize.minimumImageSize,
  "maximumImageSize": imgSize.maximumImageSize,
  "templateIdRegex": /^[0-9a-zA-Z_-]+$/,
  "successHttpStatusCode": 200,
  "headerUnauthorized": "Unauthorized",
  "unauthorizedMessage": "Current user is not authorized. Please contact your system administrator",
  "sessionExpiredMessage": "Your session has expired. Click OK to login again",
  "headerSessionExpired": "Session expired",
  "headerOverallHealth": "Backend is not ready",
  "overallHealthMessage": "Backend is not ready. Please contact your system administrator",
  "headerTemplateUnderProcessing": "Template under processing",
  "infoTemplateUnderProcessing": "Template name cannot be changed"
}

export const ToolTipMessages = {
  "deleteTemplatesButtonActive": "Delete selected templates",
  "deleteBBX": "Delete bounding box",
  "deleteTemplatesButtonDisabled": "Select templates to delete",
  "downloadTemplatesButtonActive": "Download selected templates",
  "downloadTemplatesButtonDisabled": "Select templates to download",
  "editTemplate": "Edit template",
  "cropImageButton": "Crop image",
  "resetImageButton": "Clear image",
  "zoomInButton": "Zoom in",
  "zoomOutButton": "Zoom out",
  "saveCroppedImageButton": "Save cropped image",
  "cancelCropButton": "Cancel image cropping"
}